interface CreditCardData {
  id: string;
  name: string;
  type: 'platinum' | 'gold' | 'black';
  number: string;
  balance: number;
  limit: number;
  expiry: string;
}

export const mockCreditCards: CreditCardData[] = [
  {
    id: '1',
    name: 'Platinum Rewards',
    type: 'platinum',
    number: '4532 1234 5678 9012',
    balance: 2843.5,
    limit: 15000,
    expiry: '12/27',
  },
  {
    id: '2',
    name: 'Gold Cashback',
    type: 'gold',
    number: '5432 9876 5432 1098',
    balance: 1205.75,
    limit: 8000,
    expiry: '08/26',
  },
  {
    id: '3',
    name: 'Black Elite',
    type: 'black',
    number: '3782 822463 10005',
    balance: 5432.25,
    limit: 25000,
    expiry: '03/28',
  },
];

export const mockAnalyticsData = {
  monthlyTrends: [
    { month: 'Jan', income: 5200, expenses: 3800 },
    { month: 'Feb', income: 5400, expenses: 3600 },
    { month: 'Mar', income: 5100, expenses: 4100 },
    { month: 'Apr', income: 5800, expenses: 4200 },
    { month: 'May', income: 5600, expenses: 3900 },
    { month: 'Jun', income: 6000, expenses: 4300 },
  ],
  categoryBreakdown: [
    { category: 'Food & Dining', amount: 1250, percentage: 28 },
    { category: 'Transportation', amount: 890, percentage: 20 },
    { category: 'Shopping', amount: 675, percentage: 15 },
    { category: 'Entertainment', amount: 445, percentage: 10 },
    { category: 'Bills & Utilities', amount: 780, percentage: 17 },
    { category: 'Healthcare', amount: 325, percentage: 7 },
    { category: 'Other', amount: 135, percentage: 3 },
  ],
  insights: [
    'Your food spending increased 15% this month compared to last month.',
    'Great job! You saved $250 more than your target this month.',
    'Consider setting up automatic transfers to boost your emergency fund.',
    'Your transportation costs are 20% below average for your income bracket.',
  ],
};

export const mockFinancialOverview = {
  totalBalance: 18266.25,
  monthlyIncome: 6000,
  monthlyExpenses: 4300,
  netIncome: 1700,
  accounts: [
    {
      id: 1,
      name: 'Main Checking',
      type: 'checking',
      balance: 3266.25,
      currency: 'USD',
    },
    {
      id: 2,
      name: 'Savings Plus',
      type: 'savings',
      balance: 15000,
      currency: 'USD',
    },
  ],
  recentTransactions: [
    {
      id: '1',
      amount: -75.5,
      description: 'Grocery Store',
      category: 'Food & Dining',
      date: '2024-12-30',
      type: 'expense',
    },
    {
      id: '2',
      amount: 2500,
      description: 'Salary Deposit',
      category: 'Income',
      date: '2024-12-29',
      type: 'income',
    },
    {
      id: '3',
      amount: -45.0,
      description: 'Gas Station',
      category: 'Transportation',
      date: '2024-12-28',
      type: 'expense',
    },
  ],
};

export const mockUser = {
  id: 'mock-user-123',
  email: 'demo@financefriend.com',
  firstName: 'Demo',
  lastName: 'User',
  profilePicture: null,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
};
